import React, { Component } from 'react';
import { Form, Field } from 'react-final-form';
import config from '../config';

class SignInBox extends Component {
  constructor(props) {
    super(props);

    this.state = {
      errorUsername: '',
      errorUsernameShow: false,
      errorPassword: '',
      errorPasswordShow: false,
      errorMessage: '',
      errorMessageShow: false,
      errorMain: '',
      errorMainShow: false,
      lastTyped: '',
      showAllErrors: false,
      isSubmitting: false,
      isAccountMenuOpen: false,
      isLoggingOut: false,
    };
  }

  onSubmit = (values, form) => {
    const {
      setIsUserSignedIn,
      setUser,
      setDoctors,
      setInsurances,
      setBodilyParts,
      setOriginalDoctors,
      onSuccessfulSignIn,
    } = this.props;

    const csrfToken = localStorage.getItem('csrfToken');

    this.setState({
      isSubmitting: true,
      errorMessage: '',
      errorMessageShow: false,
    });

    fetch(`${config.API_BASE_URL}/api/v1/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken,
      },
      credentials: 'include',
      body: JSON.stringify(values),
    })
      .then((res) => {
        if (res.ok) {
          res.json().then((response) => {
            console.log('response /login', response);

            setIsUserSignedIn(true);
            setUser(response.user);
            setDoctors(response.doctors);
            setOriginalDoctors(response.doctors);
            setInsurances(response.insurances);
            setBodilyParts(response.bodily_parts);

            if (form) {
              form.reset();
            }

            this.setState({
              isSubmitting: false,
              showAllErrors: false,
              isAccountMenuOpen: false,
            });

            if (onSuccessfulSignIn) {
              onSuccessfulSignIn();
            }
          });
        } else {
          res.json().then((errors) => {
            const errorMessage = errors.error || 'Login failed. Please try again.';

            this.setState({
              errorMessage,
              errorMessageShow: true,
              isSubmitting: false,
            });
          });
        }
      })
      .catch((error) => {
        console.error('Login request failed:', error);

        this.setState({
          errorMessage: 'Unable to sign in. Please try again.',
          errorMessageShow: true,
          isSubmitting: false,
        });
      });
  };

  toggleAccountMenu = () => {
    this.setState((prevState) => ({
      isAccountMenuOpen: !prevState.isAccountMenuOpen,
    }));
  };

  closeAccountMenu = () => {
    this.setState({
      isAccountMenuOpen: false,
    });
  };

  getDisplayName = () => {
    const { user } = this.props;

    return user?.username || user?.email || 'Signed in user';
  };

  getUserInitial = () => {
    const displayName = this.getDisplayName();

    return displayName.charAt(0).toUpperCase();
  };

  getRoleLabel = () => {
    const { user } = this.props;

    if (user?.super_admin) return 'Super Admin';
    if (user?.admin) return 'Admin';

    return 'User';
  };

  handleLogoutClick = async () => {
    const { handleLogout } = this.props;

    if (this.state.isLoggingOut) return;

    this.setState({
      isLoggingOut: true,
      isAccountMenuOpen: false,
      errorMessage: '',
      errorMessageShow: false,
    });

    try {
      if (handleLogout) {
        await Promise.resolve(handleLogout());
      }
    } catch (error) {
      console.error('Logout failed:', error);

      this.setState({
        isLoggingOut: false,
        errorMessage: 'Unable to log out. Please try again.',
        errorMessageShow: true,
      });
    }
  };

  renderErrorPassword = (error) => {
    if (error && this.state.showAllErrors) {
      return (
        <p className="mt-2 text-xs font-semibold text-rose-200">
          {error}
        </p>
      );
    }

    return null;
  };

  renderErrorMain = (error) => {
    if (error && this.state.showAllErrors) {
      return (
        <p className="mt-2 text-xs font-semibold text-rose-200">
          {error}
        </p>
      );
    }

    return null;
  };

  inputChangeHandler = (fieldName) => {
    if (fieldName === 'username') {
      this.setState({
        errorUsername: '',
        errorUsernameShow: false,
      });
    } else if (fieldName === 'password') {
      this.setState({
        errorPassword: '',
        errorPasswordShow: false,
      });
    }
  };

  renderErrorUsername = (error) => {
    if (error && this.state.showAllErrors) {
      return (
        <p className="mt-2 text-xs font-semibold text-rose-200">
          {error}
        </p>
      );
    }

    return null;
  };

  renderSendButton = (values, errors, form) => {
    const hasRequiredValues = Boolean(values.username && values.password);
    const hasErrors = Object.keys(errors).length > 0;
    const isDisabled = this.state.isSubmitting;

    return (
      <div className="mt-5">
        {this.state.errorMessageShow && (
          <div className="mb-4 rounded-2xl border border-rose-300/20 bg-rose-500/10 px-4 py-3 text-sm font-semibold leading-5 text-rose-100">
            {this.state.errorMessage}
          </div>
        )}

        <button
          onClick={(event) => {
            event.preventDefault();

            if (!hasErrors && hasRequiredValues) {
              this.onSubmit(values, form);
            } else {
              this.setState({ showAllErrors: true });
            }
          }}
          disabled={isDisabled}
          type="submit"
          className="group relative inline-flex min-h-[52px] w-full items-center justify-center overflow-hidden rounded-2xl border border-cyan-300/30 bg-cyan-400/15 px-5 py-3 text-sm font-black uppercase tracking-[0.14em] text-cyan-100 shadow-lg shadow-cyan-950/30 transition hover:-translate-y-0.5 hover:border-cyan-200/70 hover:bg-cyan-300/20 disabled:cursor-not-allowed disabled:opacity-60 disabled:hover:translate-y-0"
        >
          <span className="absolute inset-0 translate-x-[-120%] bg-gradient-to-r from-transparent via-cyan-200/20 to-transparent transition duration-700 group-hover:translate-x-[120%]" />

          {this.state.isSubmitting ? (
            <span className="relative inline-flex items-center gap-3">
              <span className="h-5 w-5 animate-spin rounded-full border-2 border-cyan-100/30 border-t-cyan-100" />
              Signing In
            </span>
          ) : (
            <span className="relative">
              Sign In
            </span>
          )}
        </button>
      </div>
    );
  };

  renderLogoutButton = () => {
    return (
      <button
        type="button"
        onClick={this.handleLogoutClick}
        disabled={this.state.isLoggingOut}
        className="group relative inline-flex min-h-[50px] w-full items-center justify-center overflow-hidden rounded-2xl border border-rose-300/20 bg-rose-500/10 px-5 py-3 text-sm font-black uppercase tracking-[0.14em] text-rose-100 transition hover:-translate-y-0.5 hover:border-rose-200/50 hover:bg-rose-400/15 disabled:cursor-not-allowed disabled:opacity-70 disabled:hover:translate-y-0"
      >
        <span className="absolute inset-0 translate-x-[-120%] bg-gradient-to-r from-transparent via-rose-200/20 to-transparent transition duration-700 group-hover:translate-x-[120%]" />

        {this.state.isLoggingOut ? (
          <span className="relative inline-flex items-center gap-3">
            <span className="h-5 w-5 animate-spin rounded-full border-2 border-rose-100/30 border-t-rose-100" />
            Logging Out
          </span>
        ) : (
          <span className="relative">
            Logout
          </span>
        )}
      </button>
    );
  };

  renderAccountDetail = (label, value) => {
    if (value === null || value === undefined || value === '') return null;

    return (
      <div className="rounded-2xl border border-white/10 bg-slate-950/70 px-4 py-3">
        <p className="text-[10px] font-black uppercase tracking-[0.2em] text-slate-500">
          {label}
        </p>

        <p className="mt-1 break-words text-sm font-bold text-slate-100">
          {String(value)}
        </p>
      </div>
    );
  };

  renderNavbarAccountPanel = () => {
    const { user } = this.props;
    const displayName = this.getDisplayName();
    const roleLabel = this.getRoleLabel();

    return (
      <div>
        <div className="border-b border-white/10 bg-cyan-400/10 px-5 py-4">
          <div className="flex items-start gap-3">
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl border border-cyan-300/25 bg-cyan-400/15 text-lg font-black text-cyan-100 shadow-lg shadow-cyan-950/30">
              {this.getUserInitial()}
            </div>

            <div className="min-w-0">
              <p className="text-xs font-black uppercase tracking-[0.28em] text-cyan-300">
                Signed In
              </p>

              <h3 className="mt-1 break-words text-lg font-black text-white">
                {displayName}
              </h3>

              <p className="mt-1 text-sm font-semibold text-cyan-100/80">
                {roleLabel}
              </p>
            </div>
          </div>
        </div>

        <div className="max-h-[55vh] overflow-y-auto p-4">
          <div className="grid gap-3">
            {this.renderAccountDetail('Username', user?.username)}
            {this.renderAccountDetail('Email', user?.email)}
            {this.renderAccountDetail('Role', roleLabel)}
            {this.renderAccountDetail('Admin', user?.admin ? 'Yes' : 'No')}
            {this.renderAccountDetail('Super Admin', user?.super_admin ? 'Yes' : 'No')}
            {user?.id && this.renderAccountDetail('User ID', user.id)}
          </div>
        </div>

        <div className="border-t border-white/10 p-4">
          {this.renderLogoutButton()}

          <p className="mt-3 text-center text-xs leading-5 text-slate-500">
            Keep this session active while processing videos.
          </p>
        </div>
      </div>
    );
  };

  renderSignedInDropdown = () => {
    const { user } = this.props;
    const displayName = this.getDisplayName();
    const roleLabel = this.getRoleLabel();

    return (
      <div className="relative">
        <button
          type="button"
          onClick={this.toggleAccountMenu}
          disabled={this.state.isLoggingOut}
          className={[
            'group flex w-full items-center justify-between gap-4 rounded-3xl border px-4 py-4 text-left shadow-2xl shadow-slate-950/30 transition disabled:cursor-not-allowed disabled:opacity-70',
            this.state.isAccountMenuOpen
              ? 'border-cyan-300/35 bg-cyan-400/15'
              : 'border-white/10 bg-slate-950/65 hover:border-cyan-300/25 hover:bg-cyan-400/10',
          ].join(' ')}
        >
          <div className="flex min-w-0 items-center gap-3">
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl border border-cyan-300/25 bg-cyan-400/15 text-lg font-black text-cyan-100 shadow-lg shadow-cyan-950/30">
              {this.getUserInitial()}
            </div>

            <div className="min-w-0">
              <p className="text-[10px] font-black uppercase tracking-[0.28em] text-cyan-300">
                Account
              </p>

              <p className="mt-1 truncate text-base font-black text-white">
                {displayName}
              </p>

              <p className="mt-0.5 text-xs font-semibold text-slate-400">
                {roleLabel}
              </p>
            </div>
          </div>

          <div
            className={[
              'flex h-9 w-9 shrink-0 items-center justify-center rounded-2xl border border-cyan-300/20 bg-slate-950/60 text-cyan-200 transition',
              this.state.isAccountMenuOpen ? 'rotate-180' : '',
            ].join(' ')}
          >
            ˅
          </div>
        </button>

        {this.state.isAccountMenuOpen && (
          <div className="absolute left-0 right-0 top-[calc(100%+0.75rem)] z-30 overflow-hidden rounded-3xl border border-cyan-300/20 bg-slate-950/95 shadow-2xl shadow-cyan-950/40 backdrop-blur-2xl">
            <div className="border-b border-white/10 bg-cyan-400/10 px-5 py-4">
              <p className="text-xs font-black uppercase tracking-[0.28em] text-cyan-300">
                Signed In
              </p>

              <h3 className="mt-1 break-words text-lg font-black text-white">
                {displayName}
              </h3>

              <p className="mt-1 text-sm font-semibold text-cyan-100/80">
                {roleLabel}
              </p>
            </div>

            <div className="grid gap-3 p-4">
              {this.renderAccountDetail('Username', user?.username)}
              {this.renderAccountDetail('Email', user?.email)}
              {this.renderAccountDetail('Role', roleLabel)}
              {this.renderAccountDetail('Admin', user?.admin ? 'Yes' : 'No')}
              {this.renderAccountDetail('Super Admin', user?.super_admin ? 'Yes' : 'No')}

              {user?.id && this.renderAccountDetail('User ID', user.id)}
            </div>

            <div className="border-t border-white/10 p-4">
              {this.renderLogoutButton()}

              <p className="mt-3 text-center text-xs leading-5 text-slate-500">
                Keep this session active while processing videos.
              </p>
            </div>
          </div>
        )}

        <div className="mt-5 rounded-3xl border border-cyan-300/10 bg-cyan-400/5 p-4">
          <p className="text-xs font-black uppercase tracking-[0.24em] text-cyan-300">
            Pipeline Ready
          </p>

          <p className="mt-2 text-sm leading-6 text-slate-300">
            Upload, queue processing, review subtitles, and download the final video.
          </p>
        </div>
      </div>
    );
  };

  renderSignInForm = ({ compact = false } = {}) => {
    return (
      <div className={compact ? 'p-5' : 'flex h-full min-h-[420px] flex-col justify-between'}>
        <div>
          <div className="inline-flex h-14 w-14 items-center justify-center rounded-2xl border border-cyan-300/20 bg-cyan-400/10 text-2xl shadow-lg shadow-cyan-950/20">
            🔐
          </div>

          <p className="mt-5 text-xs font-black uppercase tracking-[0.32em] text-cyan-300">
            Secure Access
          </p>

          <h2 className="mt-2 text-2xl font-black tracking-tight text-white">
            Sign in to start
          </h2>

          <p className="mt-3 text-sm leading-6 text-slate-300">
            Access the upload pipeline, live processing updates, subtitle review, and final video download.
          </p>
        </div>

        <Form
          validate={(values) => {
            const errors = {};

            if (!values.username) {
              errors.username = 'Username is empty';
            } else if (values.username.length > 20) {
              errors.username = 'Username is too long';
            }

            if (!values.password) {
              errors.password = 'Password is empty';
            } else if (values.password.length > 20) {
              errors.password = 'Password is too long';
            }

            return errors;
          }}
          onSubmit={this.onSubmit}
          render={({ handleSubmit, values, errors, form }) => (
            <form onSubmit={handleSubmit} className="mt-8">
              <div className="space-y-4">
                <div>
                  <label className="mb-2 block text-xs font-black uppercase tracking-[0.18em] text-slate-400">
                    Username
                  </label>

                  <Field name="username">
                    {({ input }) => (
                      <input
                        {...input}
                        placeholder="Username"
                        onChange={(event) => {
                          input.onChange(event);
                          this.inputChangeHandler('username');
                        }}
                        className={[
                          'w-full rounded-2xl border bg-slate-950/70 px-4 py-3 text-sm font-semibold text-white outline-none transition placeholder:text-slate-600 focus:bg-slate-950/90',
                          errors.username && this.state.showAllErrors
                            ? 'border-rose-300/50 focus:border-rose-200'
                            : 'border-white/10 focus:border-cyan-300/60',
                        ].join(' ')}
                      />
                    )}
                  </Field>

                  {this.renderErrorUsername(errors.username)}
                </div>

                <div>
                  <label className="mb-2 block text-xs font-black uppercase tracking-[0.18em] text-slate-400">
                    Password
                  </label>

                  <Field name="password">
                    {({ input }) => (
                      <input
                        {...input}
                        placeholder="Password"
                        type="password"
                        onChange={(event) => {
                          input.onChange(event);
                          this.inputChangeHandler('password');
                        }}
                        className={[
                          'w-full rounded-2xl border bg-slate-950/70 px-4 py-3 text-sm font-semibold text-white outline-none transition placeholder:text-slate-600 focus:bg-slate-950/90',
                          errors.password && this.state.showAllErrors
                            ? 'border-rose-300/50 focus:border-rose-200'
                            : 'border-white/10 focus:border-cyan-300/60',
                        ].join(' ')}
                      />
                    )}
                  </Field>

                  {this.renderErrorPassword(errors.password)}
                </div>

                {this.renderErrorMain(this.state.errorMain)}
              </div>

              {this.renderSendButton(values, errors, form)}

              <div className="mt-5 rounded-2xl border border-cyan-300/10 bg-cyan-400/5 px-4 py-3">
                <p className="text-xs font-semibold leading-5 text-slate-400">
                  Production mode is active. Your uploads process through the Rails worker, Redis queue, Google speech recognition, and S3 storage pipeline.
                </p>
              </div>
            </form>
          )}
        />
      </div>
    );
  };

  render() {
    const { isUserSignedIn, user, variant } = this.props;

    if (variant === 'navbar') {
      if (user && isUserSignedIn) {
        return this.renderNavbarAccountPanel();
      }

      return this.renderSignInForm({ compact: true });
    }

    if (user && isUserSignedIn) {
      return this.renderSignedInDropdown();
    }

    return this.renderSignInForm();
  }
}

export default SignInBox;